import React, { useState, useEffect } from 'react';
import GameScorecard from '@/src/game/GameScorecard';
import { Game, TeamEvent } from '../types/games_api_types';
import TeamEventScorecard from '@/src/team_event/TeamEventScorecard';

export default function Today() {
  const [scheduleData, setScheduleData] = useState<(Game | TeamEvent)[]>([]);

  useEffect(() => {
    let intervalId: number | undefined;

    const getData = async () => {
      try {
        const startOfDay = Math.floor(new Date().setHours(0, 0, 0, 0) / 1000);
        const response = await fetch(
          `/api/v1/today.json?day_start=${startOfDay}`,
          {
            cache: 'no-cache',
          },
        );
        const data = await response.json();
        setScheduleData(data.games.concat(data.team_events));
      } catch (e) {
        // Swallow errors to avoid breaking the interval loop
        // Optionally, we could log to an error reporting service
      }
    };

    getData();
    intervalId = window.setInterval(getData, 10000);

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, []);

  if (scheduleData.length === 0) {
    return null;
  }

  const todayStr = `${new Date().toLocaleString('default', { month: 'short' })} ${new Date().getDate()}`;

  return (
    <div id="today" className="tray">
      <div className="inner-tray" style={{ paddingTop: '3.5em' }}>
        <div className="corner left">TODAY</div>
        <div className="corner right">{todayStr}</div>
        {scheduleData.map((scheduleItem) =>
          'home_team' in scheduleItem ? (
            <GameScorecard
              key={`game-${scheduleItem.sport}-${scheduleItem.start_time}`}
              game={scheduleItem}
              today={true}
            />
          ) : (
            <TeamEventScorecard
              key={`team-event-${scheduleItem.uid}`}
              teamEvent={scheduleItem}
            />
          ),
        )}
      </div>
    </div>
  );
}
